var map = {
	"./complex.png": 667,
	"./es.png": 668,
	"./js.png": 669,
	"./logo.png": 661,
	"./marker.png": 670,
	"./min.png": 671,
	"./oceans.png": 672,
	"./play.png": 673,
	"./playcomment.png": 674,
	"./tangramplay.png": 675,
	"./vectortiles.gif": 676
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 666;



/*****************
 ** WEBPACK FOOTER
 ** ./Assets/images \.(png|gif)$
 ** module id = 666
 ** module chunks = 1
 **/